import { render, staticRenderFns } from "./BranchTable.vue?vue&type=template&id=46f6c37a&"
import script from "./BranchTable.vue?vue&type=script&lang=js&"
export * from "./BranchTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46f6c37a')) {
      api.createRecord('46f6c37a', component.options)
    } else {
      api.reload('46f6c37a', component.options)
    }
    module.hot.accept("./BranchTable.vue?vue&type=template&id=46f6c37a&", function () {
      api.rerender('46f6c37a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/organization/branches/BranchTable.vue"
export default component.exports